// Load-More variant of FilteringModule.
// Appends the next page of results to the existing list instead of replacing them.
// Supports both a "Load More" button and optional infinite-scroll via IntersectionObserver.
// Auto-initialized for pages containing .filtered-content-load-more.
// Set data-load-mode="infinite-scroll" on the section element to enable scroll mode.

function LoadMoreModule(options) {
    options = options || {};
    var infiniteScroll = options.infiniteScroll === true;

    var lmSelectors = Object.assign({
        form:           '#filter-form',
        filterSelects:  '.filter-select',
        keyword:        '#keyword',
        clearButton:    '#clear-filters',
        results:        '#results-container',
        loadingOverlay: '#loading-overlay',
        ajaxUrlSource:  '.filtered-content-load-more',
        loadMoreBtn:    '#load-more-btn',
        loadMoreWrap:   '#load-more-wrap',
        scrollSentinel: '#scroll-sentinel'
    }, options.selectors);

    var lmState = { hasMore: true, nextPageUrl: null, observer: null, loadMoreWrap: null, isLoading: false };

    // Read the URL of the "Next" page from a pager element (live DOM or parsed response doc).
    // The <div id="results-pager"> is invalid inside a <ul>, so browsers hoist it out;
    // always search the root document/body, never a fragment.
    function getNextPageUrl(root) {
        var pager = root.querySelector('#results-pager');
        if (!pager) return null;
        var activeLi = pager.querySelector('li.page-item.active');
        if (!activeLi) return null;
        var nextLi = activeLi.nextElementSibling;
        // Skip any non-page-item siblings (e.g. Next button li if it reappears later)
        while (nextLi && !nextLi.classList.contains('page-item')) {
            nextLi = nextLi.nextElementSibling;
        }
        var nextLink = nextLi ? nextLi.querySelector('a[href]') : null;
        return nextLink ? nextLink.href : null;
    }

    // Merge Sitefinity's next-page path with the current filter query string.
    function buildNextUrl(nextPageUrl, queryString) {
        var path = nextPageUrl;
        try { path = new URL(nextPageUrl).pathname; } catch (e) {}
        return queryString ? (path + '?' + queryString) : path;
    }

    function showLoadMore(visible) {
        if (!infiniteScroll && lmState.loadMoreWrap) {
            lmState.loadMoreWrap.style.display = visible ? '' : 'none';
        }
    }

    function updateSentinel() {
        if (!infiniteScroll || !lmState.observer) return;
        var sentinel = document.querySelector(lmSelectors.scrollSentinel);
        if (!sentinel) return;
        if (lmState.hasMore && !lmState.isLoading) {
            lmState.observer.observe(sentinel);
        } else {
            lmState.observer.unobserve(sentinel);
        }
    }

    function resolveAjaxUrl() {
        var el = document.querySelector(lmSelectors.ajaxUrlSource);
        if (!el) return null;
        var url = el.dataset.ajaxUrl || '';
        url = url.replace(/-page-\d+-?/gi, '').replace(/\/page\/\d+\/?/gi, '').replace(/\/$/, '');
        return url;
    }

    async function fetchResults(resetPagination) {
        resetPagination = resetPagination === true;
        if (lmState.isLoading) return;
        if (!lmState.hasMore && !resetPagination) return;
        if (resetPagination) {
            lmState.nextPageUrl = null;
            lmState.hasMore = false;
        }

        lmState.isLoading = true;
        updateSentinel();

        var qs  = module.getQueryString(true);
        qs = qs ? qs + '&isAjax=1' : 'isAjax=1';
        var url = resetPagination
            ? (module.state.ajaxUrl + '?' + qs)
            : buildNextUrl(lmState.nextPageUrl, qs);

        module.showLoading();
        showLoadMore(false);

        try {
            var response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error('HTTP error! status: ' + response.status);

            var html = await response.text();
            if (!html || html.trim().length === 0) throw new Error('Empty response');

            var doc      = new DOMParser().parseFromString(html, 'text/html');
            var fragment = doc.querySelector(lmSelectors.results);
            if (!fragment) throw new Error('Results container not found in response');

            if (resetPagination) {
                module.state.results.outerHTML = fragment.outerHTML;
                module.state.results = document.querySelector(lmSelectors.results);
                module.updateCounter();
            } else {
                var list     = module.state.results;
                var oldPager = list.querySelector('#results-pager');
                if (oldPager) oldPager.remove();
                var newItems = Array.from(fragment.querySelectorAll(':scope > li'));
                newItems.forEach(function(li) { list.appendChild(li); });
                var newPager = fragment.querySelector('#results-pager');
                if (newPager) list.appendChild(newPager);
                module.updateCounter();
            }

            lmState.nextPageUrl = getNextPageUrl(doc);
            lmState.hasMore = !!lmState.nextPageUrl;
            module.updateClearButton();
        } catch (error) {
            if (resetPagination) module.renderError(module.state.results, error);
        } finally {
            lmState.isLoading = false;
            module.hideLoading();
            showLoadMore(lmState.hasMore);
            updateSentinel();
        }
    }

    function bindEvents() {
        module.state.selects.forEach(function(select) {
            select.addEventListener('change', function() {
                module.removePaginationInputs();
                module.fetchResults(true);
            });
        });

        var submitBtn = document.querySelector('#submit-filters');
        if (submitBtn) {
            submitBtn.addEventListener('click', function() {
                module.removePaginationInputs();
                module.fetchResults(true);
            });
        }

        if (module.state.keyword) {
            module.state.keyword.addEventListener('keypress', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    module.removePaginationInputs();
                    module.fetchResults(true);
                }
            });
        }

        if (module.state.clearBtn) {
            module.state.clearBtn.addEventListener('click', function() {
                module.state.form.reset();
                if (module.state.keyword) module.state.keyword.value = '';
                module.state.selects.forEach(function(s) { s.selectedIndex = 0; });
                window.history.pushState({}, '', module.state.ajaxUrl);
                module.fetchResults(true);
            });
        }

        lmState.loadMoreWrap = document.querySelector(lmSelectors.loadMoreWrap);
        var btn = document.querySelector(lmSelectors.loadMoreBtn);
        if (!infiniteScroll && btn) {
            btn.addEventListener('click', function() { module.fetchResults(false); });
        }

        if (infiniteScroll && ('IntersectionObserver' in window)) {
            var sentinel = document.querySelector(lmSelectors.scrollSentinel);
            if (sentinel) {
                lmState.observer = new IntersectionObserver(function(entries) {
                    if (entries[0].isIntersecting && lmState.hasMore && !lmState.isLoading) module.fetchResults(false);
                }, { rootMargin: '200px' });
                lmState.observer.observe(sentinel);
            }
        }

        window.addEventListener('popstate', function() { location.reload(); });
    }

    function init() {
        module.state.form     = document.querySelector(lmSelectors.form);
        module.state.results  = document.querySelector(lmSelectors.results);
        module.state.overlay  = document.querySelector(lmSelectors.loadingOverlay);
        module.state.keyword  = document.querySelector(lmSelectors.keyword);
        module.state.clearBtn = document.querySelector(lmSelectors.clearButton);
        module.state.selects  = Array.from(document.querySelectorAll(lmSelectors.filterSelects));
        module.state.ajaxUrl  = module.resolveAjaxUrl();

        if (!module.state.results || !module.state.overlay || !module.state.ajaxUrl) {
            return false;
        }
        // Seed the first next-page URL from the pager already in the live DOM.
        lmState.nextPageUrl = getNextPageUrl(document);
        lmState.hasMore     = !!lmState.nextPageUrl;
        // Hide load-more button immediately if there's only one page.
        lmState.loadMoreWrap = document.querySelector(lmSelectors.loadMoreWrap);
        if (!lmState.hasMore && lmState.loadMoreWrap) lmState.loadMoreWrap.style.display = 'none';
        module.bindEvents();
        return true;
    }

    var module = Object.assign(
        FilteringModule({ selectors: lmSelectors }),
        { resolveAjaxUrl: resolveAjaxUrl, fetchResults: fetchResults, bindEvents: bindEvents, init: init }
    );
    return module;
}

// Auto-initialize on pages that use the load-more view variant.
document.addEventListener('DOMContentLoaded', function() {
    var section = document.querySelector('.filtered-content-load-more');
    if (!section) return;
    var isTeamVariant = section.dataset.variant === 'team-members';
    LoadMoreModule({
        infiniteScroll: section.dataset.loadMode === 'infinite-scroll',
        selectors: isTeamVariant ? { ajaxUrlSource: '[data-variant="team-members"]' } : undefined,
    }).init();
});
